import React from 'react';
import {
  MapContainer,
  TileLayer,
  Marker,
  Popup,
  LayersControl
} from 'react-leaflet';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';

// Fix Leaflet's default icon issue in React
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
});

const { BaseLayer } = LayersControl;

const MapView = ({ data, link }) => {
  return (
    <MapContainer
      center={[6.18, 46.5]}
      maxBounds={[[4.0, 45.0], [7.2, 48.0]]}
      maxBoundsViscosity={1.0}
      zoom={8}
      style={{ height: '600px', width: '100%' }}
    >
      <LayersControl position="topright">
        <BaseLayer checked name="Street View">
          <TileLayer
            url="https://{s}.tile.openstreetmap.fr/osmfr/{z}/{x}/{y}.png"
            attribution='&copy; OpenStreetMap contributors, Tiles style by <a href="https://openstreetmap.fr/">OpenStreetMap France</a>'
          />
        </BaseLayer>

        <BaseLayer name="Satellite View">
  <TileLayer
    url="https://mt1.google.com/vt/lyrs=s&x={x}&y={y}&z={z}"
    attribution="© Google"
  />
</BaseLayer>

      </LayersControl>

      {data.map((loc) => {
        if (!loc.coordinate || !loc.coordinate.includes(',')) return null;
        const [lat, lng] = loc.coordinate.split(',').map(c => Number(c.trim()));
        return (
          <Marker key={loc.id} position={[lat, lng]}>
            <Popup>
              {Object.entries(loc).map(([key, value]) =>
                key !== 'id' && key !== 'coordinate' ? (
                  <div key={key}>
                    <strong>{key.charAt(0).toUpperCase() + key.slice(1)}:</strong> {value}<br />
                  </div>
                ) : null
              )}
            </Popup>
          </Marker>
        );
      })}
    </MapContainer>
  );
};

export default MapView;
